import script from "./PackagesAnnouncementModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackagesAnnouncementModal.vue?vue&type=script&setup=true&lang=ts"

import "./PackagesAnnouncementModal.vue?vue&type=style&index=0&id=11dfd9a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11dfd9a3"]])

export default __exports__